import React, { useEffect, useState } from 'react';
import mainlogo from './img/SustainabilityProLogo.png';
import loginimg from './img/sustain-login.jpg';
import username from './img/usernameicon.png';
import keyicon from './img/keyicon.png';
import eye from './img/eye.png';
import hidden from './img/hidden.png';
import { Link, useNavigate } from 'react-router-dom';
import { create } from './services/upload-files.service';
import Register from './Register';


export default function Login({ refreshPermission }) {
  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [showPass, setShowPass] = useState(false)
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };

  const handleShowPassword = () => {
    setShowPass(!showPass)
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    const errors = validateFormFields(formData);
    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
    } else {
      try {
        const res = await create(formData, 'login');
        if (res && Object.keys(res).length > 0) {
          setValidationErrors({ success: 'Successfully logged in!' })
          localStorage.setItem('userdetails', JSON.stringify(res.user));
          localStorage.setItem('email', res.user.email);
          localStorage.setItem('token', res.token);
          localStorage.setItem('permissions', JSON.stringify(res.permissions));

          refreshPermission(JSON.stringify(res.permissions));
          setTimeout(() => {
            const route = 'overview'
            navigate(route, { state: { user: res } });
          }, 200)

        } else {
          setValidationErrors({ err: 'Please Enter valid Email & Password' });
        }
      } catch (error) {
        setValidationErrors({ err: ' Please Enter valid Email & Password' });
      }
      setFormData({});
      // setValidationErrors({});
    }
  };

  const validateFormFields = (formData) => {
    const errors = {};

    if (!formData.email || formData.email.trim() === '') {
      errors.email = 'Please Enter an Email Address';
    } else if (!validateEmail(formData.email)) {
      errors.email = 'Please Enter a Valid Email Address';
    }

    if (!formData.password || formData.password.trim() === '') {
      errors.password = 'Please Enter a Password';
    }

    return errors;
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  return (
    <div className="container login-container">
      <div className="row">
        <div className="col-md-6 px-0">
          <img src={loginimg} className='login-img' alt="profile_img" />
        </div>
        <div className="col-md-6 login-form">
          <img src={mainlogo} alt="sus logo" />
          {validationErrors.success && <span className='success'>{validationErrors.success}</span>}
          <form onSubmit={handleSubmit} className="form-custom">
            <label htmlFor="email">
              User Name<em>*</em>
            </label>
            <div className="input-group">
              <span className="input-group-text">
                <img src={username} alt="username icon" />
              </span>
              <input
                type="text"
                className="form-control"
                name="email"
                value={formData.email || ''}
                placeholder="Enter Email Id"
                onChange={handleInputChange}
              />
              {validationErrors.err && <div className="login-error">{validationErrors.err}</div>}
              {validationErrors.email && <div className="error login-error">{validationErrors.email}</div>}
            </div>
            <label htmlFor="password">
              Password<em>*</em>
            </label>
            <div className="input-group">
              <span className="input-group-text">
                <img src={keyicon} alt="key icon" />
              </span>
              <input
                type={showPass ? "text" : "password"}
                className="form-control"
                name="password"
                value={formData.password || ''}
                placeholder="Password"
                onChange={handleInputChange}
              />
              <span className="input-group-text">
                <img src={showPass ? eye : hidden} alt="key icon" onClick={handleShowPassword} />
              </span>
              {validationErrors.password && <div className="error login-error">{validationErrors.password}</div>}
            </div>
            <div className="input-group">
              <button type="submit" className="btn btn-primary btn-add mt-2">
                Submit
              </button>
            </div>
            <div className="forget-password">
              <Link to="forgotpassword">Forgot Password</Link>
            </div>
          </form>
          <div className="not-a-member-yet">
            <span>Not a member yet?</span>
            
            <Link to="register">Register here</Link>
          </div>

       </div>
      </div>
    </div>
  );
}
